import createTableStore from "ds/components/Table/store/useTableStore";

import { SPACE_STACKS_COLUMN_CONFIG, SPACE_STACKS_COLUMNS_STORAGE_KEY } from "./constants";

const useSpaceDetailsStacksTableStore = createTableStore({
  storageKey: SPACE_STACKS_COLUMNS_STORAGE_KEY,
  config: SPACE_STACKS_COLUMN_CONFIG,
  version: 2,
});

export default useSpaceDetailsStacksTableStore;
